import { createReducer } from '@reduxjs/toolkit'
import { authActions } from './actions'
import { initialState } from './initialState'

/**
 * Reducer do módulo Auth
 */
export const authReducer = createReducer(initialState, (builder) => {
  builder
    // Check Auth
    .addCase(authActions.checkAuthRequest, (state) => {
      state.isCheckingAuth = true
      state.error = null
    })
    .addCase(authActions.checkAuthSuccess, (state, action) => {
      state.isCheckingAuth = false
      state.user = action.payload.user
      state.token = action.payload.token
      state.isAuthenticated = true
      state.error = null
    })
    .addCase(authActions.checkAuthFailure, (state) => {
      state.isCheckingAuth = false
      state.user = null
      state.token = null
      state.isAuthenticated = false
    })
    
    // Login
    .addCase(authActions.loginRequest, (state) => {
      state.isLoading = true
      state.error = null
    })
    .addCase(authActions.loginSuccess, (state, action) => {
      state.isLoading = false
      state.user = action.payload.user
      state.token = action.payload.token
      state.isAuthenticated = true
      state.error = null
    })
    .addCase(authActions.loginFailure, (state, action) => {
      state.isLoading = false
      state.error = action.payload.error
      state.isAuthenticated = false
    })
    
    // Logout
    .addCase(authActions.logoutRequest, (state) => {
      state.isLoading = true
    })
    .addCase(authActions.logoutSuccess, (state) => {
      state.isLoading = false
      state.user = null
      state.token = null
      state.isAuthenticated = false
      state.error = null
    })
    .addCase(authActions.logoutFailure, (state, action) => {
      state.isLoading = false
      state.error = action.payload.error
      // Mesmo com erro, limpar estado local
      state.user = null
      state.token = null
      state.isAuthenticated = false
    })
    
    // Register
    .addCase(authActions.registerRequest, (state) => {
      state.isLoading = true
      state.error = null
      state.registerResult = null
    })
    .addCase(authActions.registerSuccess, (state, action) => {
      state.isLoading = false
      state.user = action.payload.user
      state.token = action.payload.token
      state.isAuthenticated = true
      state.error = null
      state.registerResult = true
    })
    .addCase(authActions.registerFailure, (state, action) => {
      state.isLoading = false
      state.error = action.payload.error
      state.isAuthenticated = false
      state.registerResult = false
    })
    .addCase(authActions.clearRegisterResult, (state) => {
      state.registerResult = null
    })
    
    // Get Me
    .addCase(authActions.getMeRequest, (state) => {
      state.isLoading = true
      state.error = null
    })
    .addCase(authActions.getMeSuccess, (state, action) => {
      state.isLoading = false
      state.user = action.payload.user
      state.isAuthenticated = true
      state.error = null
    })
    .addCase(authActions.getMeFailure, (state, action) => {
      state.isLoading = false
      state.error = action.payload.error
      // Se falhar ao buscar dados, pode ser que o token seja inválido
      state.user = null
      state.token = null
      state.isAuthenticated = false
    })
    
    // Update User
    .addCase(authActions.updateUser, (state, action) => {
      if (state.user) {
        state.user = {
          ...state.user,
          ...action.payload,
          updatedAt: new Date()
        }
      }
    })
    
    // Clear Error
    .addCase(authActions.clearError, (state) => {
      state.error = null
    })
})

